module.exports = __webpack_public_path__ + "static/Teri-ff2fb9b1480d23a1de1f42aa6ee343e8.jpg";